import React from 'react';
import { IFlightDroneContext } from './types';

export const FlightDroneContext = React.createContext<IFlightDroneContext>({
  isLoading: false,
  refetch: () => {}
});

export const FlightDroneProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  return (
    <FlightDroneContext.Provider 
      value={{ 
        isLoading,
        refetch: () => setIsLoading(true),
      }}>
      {children}
    </FlightDroneContext.Provider>
  );
};